window.PS_LABHUB ={
 "built": "2026-08-31T16:58:29Z",
 "snapshotGeneratedAt": "2026-08-23T23:54:48Z",
 "salesSignal": "units",
 "families": [
  {
   "handle": "lab-grown-bridal-sets",
   "label": "Lab Grown Bridal Sets",
   "url": "/collections/lab-grown-bridal-sets",
   "total": 156,
   "ids": [
    "gid://shopify/Product/7305421815992",
    "gid://shopify/Product/7685897781432",
    "gid://shopify/Product/7305422012600",
    "gid://shopify/Product/7304432550072",
    "gid://shopify/Product/7305308930232",
    "gid://shopify/Product/7641272418488",
    "gid://shopify/Product/7664254189752",
    "gid://shopify/Product/7305192571064",
    "gid://shopify/Product/7641271173304",
    "gid://shopify/Product/7305710272696",
    "gid://shopify/Product/7641271730360",
    "gid://shopify/Product/7641271304376",
    "gid://shopify/Product/7641270976696",
    "gid://shopify/Product/7305751920824",
    "gid://shopify/Product/7305751756984",
    "gid://shopify/Product/7305447112888",
    "gid://shopify/Product/7304432484536",
    "gid://shopify/Product/7304432353464",
    "gid://shopify/Product/7305326461112",
    "gid://shopify/Product/7304432255160",
    "gid://shopify/Product/7305751986360",
    "gid://shopify/Product/7305751691448",
    "gid://shopify/Product/7304432156856",
    "gid://shopify/Product/10448394977464",
    "gid://shopify/Product/9153144127672",
    "gid://shopify/Product/9106073682104",
    "gid://shopify/Product/7641272778936",
    "gid://shopify/Product/7641270747320",
    "gid://shopify/Product/7305752150200",
    "gid://shopify/Product/7305446850744",
    "gid://shopify/Product/7305446785208",
    "gid://shopify/Product/7305446588600",
    "gid://shopify/Product/7305422110904",
    "gid://shopify/Product/7305421914296",
    "gid://shopify/Product/7305326526648",
    "gid://shopify/Product/7304432419000",
    "gid://shopify/Product/7304432189624",
    "gid://shopify/Product/7305710665912",
    "gid://shopify/Product/9153143799992",
    "gid://shopify/Product/7305709912248",
    "gid://shopify/Product/9153144815800",
    "gid://shopify/Product/7641272189112",
    "gid://shopify/Product/7305752412344",
    "gid://shopify/Product/7304432517304",
    "gid://shopify/Product/10448395632824",
    "gid://shopify/Product/10448395206840",
    "gid://shopify/Product/10438657900728",
    "gid://shopify/Product/10438657638584",
    "gid://shopify/Product/10438657278136",
    "gid://shopify/Product/10438657048760",
    "gid://shopify/Product/10438656786616",
    "gid://shopify/Product/10438656491704",
    "gid://shopify/Product/10438656327864",
    "gid://shopify/Product/10424759484600",
    "gid://shopify/Product/10424759419064",
    "gid://shopify/Product/10424759156920",
    "gid://shopify/Product/10420699988152",
    "gid://shopify/Product/10420699922616",
    "gid://shopify/Product/10420699562168",
    "gid://shopify/Product/10419652919480",
    "gid://shopify/Product/10419652624568",
    "gid://shopify/Product/10408754348216",
    "gid://shopify/Product/10408753856696",
    "gid://shopify/Product/10376386674872",
    "gid://shopify/Product/10376386511032",
    "gid://shopify/Product/10376386314424",
    "gid://shopify/Product/10376386150584",
    "gid://shopify/Product/10274915287224",
    "gid://shopify/Product/10274915156152",
    "gid://shopify/Product/10145128415416",
    "gid://shopify/Product/9153145012408",
    "gid://shopify/Product/9153144520888",
    "gid://shopify/Product/9153143472312",
    "gid://shopify/Product/9153143144632",
    "gid://shopify/Product/9153142718648",
    "gid://shopify/Product/9153142194360",
    "gid://shopify/Product/9106074140856",
    "gid://shopify/Product/9106074075320",
    "gid://shopify/Product/9106073649336",
    "gid://shopify/Product/9106073518264",
    "gid://shopify/Product/9106073452728",
    "gid://shopify/Product/7685898109112",
    "gid://shopify/Product/7685897846968",
    "gid://shopify/Product/7685897650360",
    "gid://shopify/Product/7664254582968",
    "gid://shopify/Product/7664254484664",
    "gid://shopify/Product/7664254386360",
    "gid://shopify/Product/7664254320824",
    "gid://shopify/Product/7664254091448",
    "gid://shopify/Product/7664254025912",
    "gid://shopify/Product/7664253993144",
    "gid://shopify/Product/7664253796536",
    "gid://shopify/Product/7664253698232",
    "gid://shopify/Product/7664253534392",
    "gid://shopify/Product/7664253403320",
    "gid://shopify/Product/7664253337784",
    "gid://shopify/Product/7664253239480",
    "gid://shopify/Product/7641272910008",
    "gid://shopify/Product/7641272680632",
    "gid://shopify/Product/7641272549560",
    "gid://shopify/Product/7641272352952",
    "gid://shopify/Product/7641272156344",
    "gid://shopify/Product/7641272090808",
    "gid://shopify/Product/7641271992504",
    "gid://shopify/Product/7641271894200",
    "gid://shopify/Product/7641271599288",
    "gid://shopify/Product/7641271468216",
    "gid://shopify/Product/7641270812856",
    "gid://shopify/Product/7305752346808",
    "gid://shopify/Product/7305752215736",
    "gid://shopify/Product/7305752051896",
    "gid://shopify/Product/7305751855288",
    "gid://shopify/Product/7305751822520",
    "gid://shopify/Product/7305751789752",
    "gid://shopify/Product/7305751724216",
    "gid://shopify/Product/7305710731448",
    "gid://shopify/Product/7305710600376",
    "gid://shopify/Product/7305710502072",
    "gid://shopify/Product/7305710436536",
    "gid://shopify/Product/7305710371000",
    "gid://shopify/Product/7305710207160",
    "gid://shopify/Product/7305710108856",
    "gid://shopify/Product/7305709977784",
    "gid://shopify/Product/7305709781176",
    "gid://shopify/Product/7305447014584",
    "gid://shopify/Product/7305446981816",
    "gid://shopify/Product/7305446916280",
    "gid://shopify/Product/7305446883512",
    "gid://shopify/Product/7305446654136",
    "gid://shopify/Product/7305446490296",
    "gid://shopify/Product/7305421848760",
    "gid://shopify/Product/7305326592184",
    "gid://shopify/Product/7305326559416",
    "gid://shopify/Product/7305326493880",
    "gid://shopify/Product/7305309028536",
    "gid://shopify/Product/7305308995768",
    "gid://shopify/Product/7305308897464",
    "gid://shopify/Product/7305308864696",
    "gid://shopify/Product/7305211379896",
    "gid://shopify/Product/7305211347128",
    "gid://shopify/Product/7305211314360",
    "gid://shopify/Product/7305211216056",
    "gid://shopify/Product/7305211183288",
    "gid://shopify/Product/7305192702136",
    "gid://shopify/Product/7305192669368",
    "gid://shopify/Product/7305192538296",
    "gid://shopify/Product/7305192472760",
    "gid://shopify/Product/7304432615608",
    "gid://shopify/Product/7304432582840",
    "gid://shopify/Product/7304432451768",
    "gid://shopify/Product/7304432386232",
    "gid://shopify/Product/7304432287928",
    "gid://shopify/Product/7304432222392",
    "gid://shopify/Product/7304432124088",
    "gid://shopify/Product/7304431993016",
    "gid://shopify/Product/7304431960248"
   ]
  },
  {
   "handle": "lab-grown-diamond-earrings",
   "label": "Lab Grown Diamond Earrings",
   "url": "/collections/lab-grown-diamond-earrings",
   "total": 70,
   "ids": [
    "gid://shopify/Product/10155069014200",
    "gid://shopify/Product/10153269067960",
    "gid://shopify/Product/10153262612664",
    "gid://shopify/Product/7328603504824",
    "gid://shopify/Product/10153265987768",
    "gid://shopify/Product/7397672911032",
    "gid://shopify/Product/7330474655928",
    "gid://shopify/Product/10155899125944",
    "gid://shopify/Product/10153277653176",
    "gid://shopify/Product/9264978559160",
    "gid://shopify/Product/7328600883384",
    "gid://shopify/Product/7328604258488",
    "gid://shopify/Product/7330474131640",
    "gid://shopify/Product/10155898634424",
    "gid://shopify/Product/10153189540024",
    "gid://shopify/Product/7328605438136",
    "gid://shopify/Product/7330473672888",
    "gid://shopify/Product/7330472198328",
    "gid://shopify/Product/7328605962424",
    "gid://shopify/Product/7328604782776",
    "gid://shopify/Product/10155899060408",
    "gid://shopify/Product/10155898863800",
    "gid://shopify/Product/10155898372280",
    "gid://shopify/Product/10155898110136",
    "gid://shopify/Product/10153282502840",
    "gid://shopify/Product/10153282207928",
    "gid://shopify/Product/10153275392184",
    "gid://shopify/Product/9264978657464",
    "gid://shopify/Product/9264978591928",
    "gid://shopify/Product/9264978493624",
    "gid://shopify/Product/9264978460856",
    "gid://shopify/Product/9264219160760",
    "gid://shopify/Product/9264219127992",
    "gid://shopify/Product/9264219095224",
    "gid://shopify/Product/9264219062456",
    "gid://shopify/Product/9264218996920",
    "gid://shopify/Product/9264218964152",
    "gid://shopify/Product/9264218931384",
    "gid://shopify/Product/9264218865848",
    "gid://shopify/Product/9264218833080",
    "gid://shopify/Product/9264218767544",
    "gid://shopify/Product/9264218636472",
    "gid://shopify/Product/9264218603704",
    "gid://shopify/Product/9264218538168",
    "gid://shopify/Product/9264218472632",
    "gid://shopify/Product/9264218407096",
    "gid://shopify/Product/9264218308792",
    "gid://shopify/Product/7395798843576",
    "gid://shopify/Product/7330692759736",
    "gid://shopify/Product/7330474426552",
    "gid://shopify/Product/7330474000568",
    "gid://shopify/Product/7330473410744",
    "gid://shopify/Product/7330473214136",
    "gid://shopify/Product/7330472951992",
    "gid://shopify/Product/7330472722616",
    "gid://shopify/Product/7330472427704",
    "gid://shopify/Product/7330471968952",
    "gid://shopify/Product/7330471739576",
    "gid://shopify/Product/7330471542968",
    "gid://shopify/Product/7328611958968",
    "gid://shopify/Product/7328611139768",
    "gid://shopify/Product/7328608452792",
    "gid://shopify/Product/7328607862968",
    "gid://shopify/Product/7328607404216",
    "gid://shopify/Product/7328606683320",
    "gid://shopify/Product/7328605077688",
    "gid://shopify/Product/7328602980536",
    "gid://shopify/Product/7328602226872",
    "gid://shopify/Product/7328601637048",
    "gid://shopify/Product/7328601047224"
   ]
  },
  {
   "handle": "lab-grown-engagement-ring",
   "label": "Lab Grown Engagement Rings",
   "url": "/collections/lab-grown-engagement-rings",
   "total": 193,
   "ids": [
    "gid://shopify/Product/9121636188344",
    "gid://shopify/Product/7601926176952",
    "gid://shopify/Product/7601926537400",
    "gid://shopify/Product/7303610007736",
    "gid://shopify/Product/7613666263224",
    "gid://shopify/Product/7303610204344",
    "gid://shopify/Product/7303236059320",
    "gid://shopify/Product/9121636253880",
    "gid://shopify/Product/9106073190584",
    "gid://shopify/Product/7702551691448",
    "gid://shopify/Product/7702551265464",
    "gid://shopify/Product/7303609647288",
    "gid://shopify/Product/7303235797176",
    "gid://shopify/Product/9106073583800",
    "gid://shopify/Product/7702551396536",
    "gid://shopify/Product/7613666525368",
    "gid://shopify/Product/7613589782712",
    "gid://shopify/Product/7601926078648",
    "gid://shopify/Product/7596596428984",
    "gid://shopify/Product/7562057285816",
    "gid://shopify/Product/7303610237112",
    "gid://shopify/Product/7303235993784",
    "gid://shopify/Product/7303235928248",
    "gid://shopify/Product/7303235731640",
    "gid://shopify/Product/7303137034424",
    "gid://shopify/Product/7303609876664",
    "gid://shopify/Product/7303609778360",
    "gid://shopify/Product/7303236223160",
    "gid://shopify/Product/7303236190392",
    "gid://shopify/Product/7702550937784",
    "gid://shopify/Product/7613588832440",
    "gid://shopify/Product/10420699955384",
    "gid://shopify/Product/10376386019512",
    "gid://shopify/Product/10274915385528",
    "gid://shopify/Product/9246811095224",
    "gid://shopify/Product/9122816360632",
    "gid://shopify/Product/9122816295096",
    "gid://shopify/Product/9122816196792",
    "gid://shopify/Product/9122816065720",
    "gid://shopify/Product/9122815934648",
    "gid://shopify/Product/9121636450488",
    "gid://shopify/Product/9121636384952",
    "gid://shopify/Product/9121636286648",
    "gid://shopify/Product/9106074271928",
    "gid://shopify/Product/9106073059512",
    "gid://shopify/Product/9083408482488",
    "gid://shopify/Product/9083407859896",
    "gid://shopify/Product/9083406680248",
    "gid://shopify/Product/9078738747576",
    "gid://shopify/Product/9078362898616",
    "gid://shopify/Product/9078362276024",
    "gid://shopify/Product/9078360244408",
    "gid://shopify/Product/9077562966200",
    "gid://shopify/Product/9077561360568",
    "gid://shopify/Product/9077561000120",
    "gid://shopify/Product/9077560475832",
    "gid://shopify/Product/9073745723576",
    "gid://shopify/Product/9073745592504",
    "gid://shopify/Product/9073745395896",
    "gid://shopify/Product/9073744969912",
    "gid://shopify/Product/9073744740536",
    "gid://shopify/Product/9073744642232",
    "gid://shopify/Product/9073744478392",
    "gid://shopify/Product/9073744314552",
    "gid://shopify/Product/7702551560376",
    "gid://shopify/Product/7702551134392",
    "gid://shopify/Product/7702550839480",
    "gid://shopify/Product/7702550446264",
    "gid://shopify/Product/7702550085816",
    "gid://shopify/Product/7702549692600",
    "gid://shopify/Product/7702490742968",
    "gid://shopify/Product/7702490480824",
    "gid://shopify/Product/7702489759928",
    "gid://shopify/Product/7690597269688",
    "gid://shopify/Product/7690597171384",
    "gid://shopify/Product/7690597040312",
    "gid://shopify/Product/7690596876472",
    "gid://shopify/Product/7690596647096",
    "gid://shopify/Product/7690596483256",
    "gid://shopify/Product/7690596319416",
    "gid://shopify/Product/7690595958968",
    "gid://shopify/Product/7690595762360",
    "gid://shopify/Product/7685898567864",
    "gid://shopify/Product/7685898469560",
    "gid://shopify/Product/7685898436792",
    "gid://shopify/Product/7685898305720",
    "gid://shopify/Product/7685898272952",
    "gid://shopify/Product/7685898174648",
    "gid://shopify/Product/7622457524408",
    "gid://shopify/Product/7622457196728",
    "gid://shopify/Product/7622361710776",
    "gid://shopify/Product/7622360170680",
    "gid://shopify/Product/7622358958264",
    "gid://shopify/Product/7622358696120",
    "gid://shopify/Product/7613667377336",
    "gid://shopify/Product/7613667082424",
    "gid://shopify/Product/7613666885816",
    "gid://shopify/Product/7613666033848",
    "gid://shopify/Product/7613665771704",
    "gid://shopify/Product/7613665444024",
    "gid://shopify/Product/7613665018040",
    "gid://shopify/Product/7613664886968",
    "gid://shopify/Product/7613664493752",
    "gid://shopify/Product/7613590208696",
    "gid://shopify/Product/7613590077624",
    "gid://shopify/Product/7613589618872",
    "gid://shopify/Product/7613589422264",
    "gid://shopify/Product/7613589192888",
    "gid://shopify/Product/7601926832312",
    "gid://shopify/Product/7601926766776",
    "gid://shopify/Product/7601926701240",
    "gid://shopify/Product/7601926635704",
    "gid://shopify/Product/7601926439096",
    "gid://shopify/Product/7601926308024",
    "gid://shopify/Product/7601926242488",
    "gid://shopify/Product/7601926045880",
    "gid://shopify/Product/7601926013112",
    "gid://shopify/Product/7601925914808",
    "gid://shopify/Product/7601925849272",
    "gid://shopify/Product/7596597379256",
    "gid://shopify/Product/7596597313720",
    "gid://shopify/Product/7596597280952",
    "gid://shopify/Product/7596597215416",
    "gid://shopify/Product/7596597084344",
    "gid://shopify/Product/7596596953272",
    "gid://shopify/Product/7596596822200",
    "gid://shopify/Product/7596596756664",
    "gid://shopify/Product/7596596691128",
    "gid://shopify/Product/7596596625592",
    "gid://shopify/Product/7596596527288",
    "gid://shopify/Product/7596596396216",
    "gid://shopify/Product/7596596330680",
    "gid://shopify/Product/7596596068536",
    "gid://shopify/Product/7566851965112",
    "gid://shopify/Product/7566851899576",
    "gid://shopify/Product/7566851866808",
    "gid://shopify/Product/7566851702968",
    "gid://shopify/Product/7566851637432",
    "gid://shopify/Product/7566851408056",
    "gid://shopify/Product/7566851276984",
    "gid://shopify/Product/7566851244216",
    "gid://shopify/Product/7566851113144",
    "gid://shopify/Product/7566851047608",
    "gid://shopify/Product/7566850982072",
    "gid://shopify/Product/7566850916536",
    "gid://shopify/Product/7566850818232",
    "gid://shopify/Product/7562057515192",
    "gid://shopify/Product/7562057482424",
    "gid://shopify/Product/7562057253048",
    "gid://shopify/Product/7562057220280",
    "gid://shopify/Product/7562057187512",
    "gid://shopify/Product/7544414535864",
    "gid://shopify/Product/7544414404792",
    "gid://shopify/Product/7544414306488",
    "gid://shopify/Product/7544413880504",
    "gid://shopify/Product/7544413716664",
    "gid://shopify/Product/7509723513016",
    "gid://shopify/Product/7509723480248",
    "gid://shopify/Product/7509723447480",
    "gid://shopify/Product/7509723349176",
    "gid://shopify/Product/7509723316408",
    "gid://shopify/Product/7509723250872",
    "gid://shopify/Product/7509723218104",
    "gid://shopify/Product/7509723185336",
    "gid://shopify/Product/7509723119800",
    "gid://shopify/Product/7509722955960",
    "gid://shopify/Product/7509722923192",
    "gid://shopify/Product/7499105894584",
    "gid://shopify/Product/7499105829048",
    "gid://shopify/Product/7499105665208",
    "gid://shopify/Product/7499105599672",
    "gid://shopify/Product/7499105468600",
    "gid://shopify/Product/7303610499256",
    "gid://shopify/Product/7303610433720",
    "gid://shopify/Product/7303610400952",
    "gid://shopify/Product/7303610335416",
    "gid://shopify/Product/7303610302648",
    "gid://shopify/Product/7303610106040",
    "gid://shopify/Product/7303609712824",
    "gid://shopify/Product/7303609581752",
    "gid://shopify/Product/7303609548984",
    "gid://shopify/Product/7303609450680",
    "gid://shopify/Product/7303609385144",
    "gid://shopify/Product/7303609319608",
    "gid://shopify/Product/7303236124856",
    "gid://shopify/Product/7303236026552",
    "gid://shopify/Product/7303235961016",
    "gid://shopify/Product/7303235895480",
    "gid://shopify/Product/7303235862712",
    "gid://shopify/Product/7303235666104",
    "gid://shopify/Product/7303235600568",
    "gid://shopify/Product/7303137067192",
    "gid://shopify/Product/7303137001656"
   ]
  },
  {
   "handle": "lab-diamond-wedding-bands",
   "label": "Lab Grown Wedding Bands",
   "url": "/collections/lab-diamond-wedding-bands",
   "total": 146,
   "ids": [
    "gid://shopify/Product/7476265943224",
    "gid://shopify/Product/7476266205368",
    "gid://shopify/Product/7485704765624",
    "gid://shopify/Product/7485706666168",
    "gid://shopify/Product/7499102617784",
    "gid://shopify/Product/7488957907128",
    "gid://shopify/Product/7485706174648",
    "gid://shopify/Product/7544414240952",
    "gid://shopify/Product/7499105042616",
    "gid://shopify/Product/10376385626296",
    "gid://shopify/Product/9153145438392",
    "gid://shopify/Product/7562057318584",
    "gid://shopify/Product/7544414142648",
    "gid://shopify/Product/7509723152568",
    "gid://shopify/Product/7499104485560",
    "gid://shopify/Product/7488957776056",
    "gid://shopify/Product/7488957710520",
    "gid://shopify/Product/7476265681080",
    "gid://shopify/Product/7544414372024",
    "gid://shopify/Product/7488957841592",
    "gid://shopify/Product/10448395665592",
    "gid://shopify/Product/10448395370680",
    "gid://shopify/Product/10448395010232",
    "gid://shopify/Product/10438658031800",
    "gid://shopify/Product/10438657736888",
    "gid://shopify/Product/10438657441976",
    "gid://shopify/Product/10438657179832",
    "gid://shopify/Product/10438656753848",
    "gid://shopify/Product/10438656295096",
    "gid://shopify/Product/10424759451832",
    "gid://shopify/Product/10424759386296",
    "gid://shopify/Product/10424759353528",
    "gid://shopify/Product/10424759320760",
    "gid://shopify/Product/10424759287992",
    "gid://shopify/Product/10424759222456",
    "gid://shopify/Product/10424759091384",
    "gid://shopify/Product/10420700053688",
    "gid://shopify/Product/10420699889848",
    "gid://shopify/Product/10420699627704",
    "gid://shopify/Product/10419652821176",
    "gid://shopify/Product/10419652591800",
    "gid://shopify/Product/10419652526264",
    "gid://shopify/Product/10408754708664",
    "gid://shopify/Product/10408754118840",
    "gid://shopify/Product/10408753692856",
    "gid://shopify/Product/10376385921208",
    "gid://shopify/Product/10376385822904",
    "gid://shopify/Product/10376385724600",
    "gid://shopify/Product/10376385560760",
    "gid://shopify/Product/10376385462456",
    "gid://shopify/Product/10274915451064",
    "gid://shopify/Product/10274915418296",
    "gid://shopify/Product/10274915352760",
    "gid://shopify/Product/10274915319992",
    "gid://shopify/Product/10274915254456",
    "gid://shopify/Product/10274915221688",
    "gid://shopify/Product/10274915188920",
    "gid://shopify/Product/10274915123384",
    "gid://shopify/Product/9153147502776",
    "gid://shopify/Product/9153147306168",
    "gid://shopify/Product/9153147076792",
    "gid://shopify/Product/9153145274552",
    "gid://shopify/Product/9083407761592",
    "gid://shopify/Product/7622359974072",
    "gid://shopify/Product/7613589127352",
    "gid://shopify/Product/7566851506360",
    "gid://shopify/Product/7566850785464",
    "gid://shopify/Product/7562057351352",
    "gid://shopify/Product/7544414732472",
    "gid://shopify/Product/7544414077112",
    "gid://shopify/Product/7509723283640",
    "gid://shopify/Product/7509723087032",
    "gid://shopify/Product/7499113562296",
    "gid://shopify/Product/7499105337528",
    "gid://shopify/Product/7499105239224",
    "gid://shopify/Product/7499104911544",
    "gid://shopify/Product/7499104878776",
    "gid://shopify/Product/7499104714936",
    "gid://shopify/Product/7499103273144",
    "gid://shopify/Product/7499103174840",
    "gid://shopify/Product/7499103076536",
    "gid://shopify/Product/7499102847160",
    "gid://shopify/Product/7499102748856",
    "gid://shopify/Product/7488958693560",
    "gid://shopify/Product/7488958660792",
    "gid://shopify/Product/7488958628024",
    "gid://shopify/Product/7488958562488",
    "gid://shopify/Product/7488958529720",
    "gid://shopify/Product/7488958496952",
    "gid://shopify/Product/7488958431416",
    "gid://shopify/Product/7488958365880",
    "gid://shopify/Product/7488958333112",
    "gid://shopify/Product/7488958300344",
    "gid://shopify/Product/7488958267576",
    "gid://shopify/Product/7488958234808",
    "gid://shopify/Product/7488958202040",
    "gid://shopify/Product/7488958169272",
    "gid://shopify/Product/7488958103736",
    "gid://shopify/Product/7488958070968",
    "gid://shopify/Product/7488958038200",
    "gid://shopify/Product/7488958005432",
    "gid://shopify/Product/7488957972664",
    "gid://shopify/Product/7488957874360",
    "gid://shopify/Product/7488957743288",
    "gid://shopify/Product/7485706567864",
    "gid://shopify/Product/7485706404024",
    "gid://shopify/Product/7485706043576",
    "gid://shopify/Product/7485705846968",
    "gid://shopify/Product/7485705617592",
    "gid://shopify/Product/7485705552056",
    "gid://shopify/Product/7485705322680",
    "gid://shopify/Product/7485705158840",
    "gid://shopify/Product/7485705060536",
    "gid://shopify/Product/7485704896696",
    "gid://shopify/Product/7485704831160",
    "gid://shopify/Product/7485704667320",
    "gid://shopify/Product/7485704536248",
    "gid://shopify/Product/7485704372408",
    "gid://shopify/Product/7485704241336",
    "gid://shopify/Product/7485704077496",
    "gid://shopify/Product/7485703979192",
    "gid://shopify/Product/7476266991800",
    "gid://shopify/Product/7476266959032",
    "gid://shopify/Product/7476266893496",
    "gid://shopify/Product/7476266795192",
    "gid://shopify/Product/7476266762424",
    "gid://shopify/Product/7476266696888",
    "gid://shopify/Product/7476266631352",
    "gid://shopify/Product/7476266565816",
    "gid://shopify/Product/7476266533048",
    "gid://shopify/Product/7476266500280",
    "gid://shopify/Product/7476266467512",
    "gid://shopify/Product/7476266401976",
    "gid://shopify/Product/7476266369208",
    "gid://shopify/Product/7476266303672",
    "gid://shopify/Product/7476266139832",
    "gid://shopify/Product/7476266074296",
    "gid://shopify/Product/7476265975992",
    "gid://shopify/Product/7476265877688",
    "gid://shopify/Product/7476265844920",
    "gid://shopify/Product/7476265779384",
    "gid://shopify/Product/7476265713848",
    "gid://shopify/Product/7476265582776",
    "gid://shopify/Product/7476265517240",
    "gid://shopify/Product/7476265451704",
    "gid://shopify/Product/7476265353400"
   ]
  },
  {
   "handle": "lab-grown-eternity-rings",
   "label": "Lab Grown Eternity Rings",
   "url": "/collections/lab-grown-eternity-rings",
   "total": 45,
   "ids": [
    "gid://shopify/Product/7300738777272",
    "gid://shopify/Product/7300093870264",
    "gid://shopify/Product/7300093837496",
    "gid://shopify/Product/7300756668600",
    "gid://shopify/Product/7476265746616",
    "gid://shopify/Product/7476265320632",
    "gid://shopify/Product/7476265189560",
    "gid://shopify/Product/7476265091256",
    "gid://shopify/Product/7476264861880",
    "gid://shopify/Product/7301086937272",
    "gid://shopify/Product/7301086904504",
    "gid://shopify/Product/7301079924920",
    "gid://shopify/Product/7301071732920",
    "gid://shopify/Product/7301071569080",
    "gid://shopify/Product/10202343768248",
    "gid://shopify/Product/10202343669944",
    "gid://shopify/Product/10202343637176",
    "gid://shopify/Product/10202343571640",
    "gid://shopify/Product/10202343538872",
    "gid://shopify/Product/10202343506104",
    "gid://shopify/Product/10202343407800",
    "gid://shopify/Product/10202343342264",
    "gid://shopify/Product/10202343309496",
    "gid://shopify/Product/10202343276728",
    "gid://shopify/Product/10202343243960",
    "gid://shopify/Product/9267852017848",
    "gid://shopify/Product/9267851985080",
    "gid://shopify/Product/9267851854008",
    "gid://shopify/Product/9106073092280",
    "gid://shopify/Product/7476265418936",
    "gid://shopify/Product/7476265255096",
    "gid://shopify/Product/7476265156792",
    "gid://shopify/Product/7476265124024",
    "gid://shopify/Product/7476264992952",
    "gid://shopify/Product/7476264927416",
    "gid://shopify/Product/7476264894648",
    "gid://shopify/Product/7301087002808",
    "gid://shopify/Product/7301080318136",
    "gid://shopify/Product/7301079892152",
    "gid://shopify/Product/7301079859384",
    "gid://shopify/Product/7301071831224",
    "gid://shopify/Product/7301071438008",
    "gid://shopify/Product/7300756635832",
    "gid://shopify/Product/7300756570296",
    "gid://shopify/Product/7300738810040"
   ]
  },
  {
   "handle": "lab-grown-diamonds-three-stone-rings",
   "label": "Lab Grown Three Stone Rings",
   "url": "/collections/lab-grown-three-stone-rings",
   "total": 33,
   "ids": [
    "gid://shopify/Product/7304057815224",
    "gid://shopify/Product/7304057880760",
    "gid://shopify/Product/7509722988728",
    "gid://shopify/Product/7499104190648",
    "gid://shopify/Product/7499103535288",
    "gid://shopify/Product/7304057782456",
    "gid://shopify/Product/7304057684152",
    "gid://shopify/Product/7304057389240",
    "gid://shopify/Product/7509723021496",
    "gid://shopify/Product/7499104059576",
    "gid://shopify/Product/7304057749688",
    "gid://shopify/Product/9122831302840",
    "gid://shopify/Product/9153146847416",
    "gid://shopify/Product/9153146585272",
    "gid://shopify/Product/9153146159288",
    "gid://shopify/Product/9153145766072",
    "gid://shopify/Product/9122831237304",
    "gid://shopify/Product/9122831073464",
    "gid://shopify/Product/9122830975160",
    "gid://shopify/Product/9122830844088",
    "gid://shopify/Product/9083408711864",
    "gid://shopify/Product/7499106058424",
    "gid://shopify/Product/7499104321720",
    "gid://shopify/Product/7499104157880",
    "gid://shopify/Product/7499103862968",
    "gid://shopify/Product/7499103600824",
    "gid://shopify/Product/7499103404216",
    "gid://shopify/Product/7304057847992",
    "gid://shopify/Product/7304057716920",
    "gid://shopify/Product/7304057651384",
    "gid://shopify/Product/7304057585848",
    "gid://shopify/Product/7304057553080",
    "gid://shopify/Product/7304057487544"
   ]
  },
  {
   "handle": "lab-grown-tennis-bracelets",
   "label": "Lab Grown Diamond Bracelets",
   "url": "/collections/lab-grown-tennis-bracelets",
   "total": 59,
   "ids": [
    "gid://shopify/Product/7302629261496",
    "gid://shopify/Product/7302629392568",
    "gid://shopify/Product/7302629228728",
    "gid://shopify/Product/9264978526392",
    "gid://shopify/Product/9258654859448",
    "gid://shopify/Product/9258654826680",
    "gid://shopify/Product/9258654793912",
    "gid://shopify/Product/9258654728376",
    "gid://shopify/Product/7370417340600",
    "gid://shopify/Product/7370417307832",
    "gid://shopify/Product/7370417275064",
    "gid://shopify/Product/7366547210424",
    "gid://shopify/Product/7366547079352",
    "gid://shopify/Product/7366547046584",
    "gid://shopify/Product/7366547013816",
    "gid://shopify/Product/7366546948280",
    "gid://shopify/Product/7366546882744",
    "gid://shopify/Product/7366546849976",
    "gid://shopify/Product/7302740082872",
    "gid://shopify/Product/7302740050104",
    "gid://shopify/Product/7302721405112",
    "gid://shopify/Product/7302721372344",
    "gid://shopify/Product/7302721306808",
    "gid://shopify/Product/7302721274040",
    "gid://shopify/Product/7302721241272",
    "gid://shopify/Product/7302629490872",
    "gid://shopify/Product/7302629425336",
    "gid://shopify/Product/7302629359800",
    "gid://shopify/Product/7302629195960",
    "gid://shopify/Product/7302597574840",
    "gid://shopify/Product/7302597542072",
    "gid://shopify/Product/7302597476536",
    "gid://shopify/Product/7302597411000",
    "gid://shopify/Product/7302597378232",
    "gid://shopify/Product/7302513459384",
    "gid://shopify/Product/7302513426616",
    "gid://shopify/Product/7302513361080",
    "gid://shopify/Product/7302513328312",
    "gid://shopify/Product/7302513295544",
    "gid://shopify/Product/7302500286648",
    "gid://shopify/Product/7302500188344",
    "gid://shopify/Product/7302500122808",
    "gid://shopify/Product/7302500024504",
    "gid://shopify/Product/7302499958968",
    "gid://shopify/Product/7302479052984",
    "gid://shopify/Product/7302479020216",
    "gid://shopify/Product/7302478954680",
    "gid://shopify/Product/7302478921912",
    "gid://shopify/Product/7302478889144",
    "gid://shopify/Product/7302141903032",
    "gid://shopify/Product/7302141837496",
    "gid://shopify/Product/7302141804728",
    "gid://shopify/Product/7302141739192",
    "gid://shopify/Product/7302141673656",
    "gid://shopify/Product/7302123225272",
    "gid://shopify/Product/7302123192504",
    "gid://shopify/Product/7302123061432",
    "gid://shopify/Product/7302123028664",
    "gid://shopify/Product/7302122963128"
   ]
  }
 ]
};
